// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zNust","option":"styles_option__fPRQZ","selected":"styles_selected__i6pRe"};